import { z } from 'zod';
import { LoosePovStyle } from './povStyle';

export const ContentTypes = z.enum(['chat', 'prose', 'vfx']);
export type ContentTypes = z.infer<typeof ContentTypes>;

export const GalateaParagraphItem = z.object({
  id: z.number(),
  pov: z.string().optional(),
  text: z.string(),
  user: z.string().optional(),
  sound: z.any(),
  styles: z.any(),
  vibrate: z.any(),
  block_id: z.string().optional(),
  remote_image: z.string().optional(),
  povStyle: LoosePovStyle,
  separator: z.boolean().optional(),
});
export type GalateaParagraphItem = z.infer<typeof GalateaParagraphItem>;

export const GalateaEpisodeContent = z.object({
  episode: z.object({
    id: z.number(),
    number: z.number(),
    title: z.string(),
    content: z.array(
      z.object({
        id: z.number(),
        type: z.enum(['chat', 'prose', 'vfx']),
        title: z.string().optional(),
        chatDeviceHolder: z.string().optional(),
        data: z.array(GalateaParagraphItem),
      }),
    ),
  }),
});

export type GalateaEpisodeContent = z.infer<typeof GalateaEpisodeContent>;

export const GalateaStoryMetadata = z.object({
  story: z.object({
    id: z.number(),
    author: z.string(),
    cover_url: z.string(),
    name: z.string(),
    slug: z.string(),
    summary_thumbnail_url: z.string(),
    free_episodes_count: z.number(),
    episodes: z.array(
      z.object({
        id: z.number(),
        number: z.number(),
        title: z.string(),
      }),
    ),
  }),
});

export type GalateaStoryMetadata = z.infer<typeof GalateaStoryMetadata>;
